import _ from 'lodash';
import memoizeOne from 'memoize-one';
import { createSelector } from 'reselect';

import { CsvMappingEntityType } from 'constants/csvMapping';

import { selectInvestorsValues, selectWarehousesValues } from 'store/accounting/selectors';
import { getCurrentSearchValue } from 'store/search/selectors';

import { getCompany } from './company.selectors';

export const selectCsvMappingsDefinition = createSelector(
  getCompany,
  ({ csvMappingsDefinition }) => csvMappingsDefinition,
);

export const selectCsvMappingsDefinitionValues = createSelector(
  selectCsvMappingsDefinition,
  Object.values,
);

export const selectCsvMappingsDefinitionFilteredOrderedValues = memoizeOne(
  (order, entityType) =>
    createSelector(
      [selectCsvMappingsDefinitionValues, getCurrentSearchValue],
      (csvMappingsDefinitionValues, searchText) =>
        _.orderBy(
          csvMappingsDefinitionValues,
          [csv => csv[order.id].toLowerCase()],
          [order.direction],
        ).filter(
          ({ csvMappingDefinitionId, name, entityType: entityTypeItem }) =>
            [csvMappingDefinitionId, name].some(value =>
              value.match(new RegExp(_.escapeRegExp(searchText), 'gim')),
            ) && entityTypeItem === entityType,
        ),
    ),
  _.isEqual,
);

export const selectEntityOptions = memoizeOne((entityType, entityId) => {
  return createSelector(
    [selectWarehousesValues, selectInvestorsValues],
    (warehouses, investors) => {
      const entityParams = {};

      switch (entityType) {
        case CsvMappingEntityType.ADVANCE_ANALYSIS_ROW:
        case CsvMappingEntityType.WAREHOUSE_PURCHASE_ADVICE_ANALYSIS_ROW:
          entityParams.id = 'warehouseBankId';
          entityParams.options = warehouses;
          break;

        case CsvMappingEntityType.PURCHASE_ADVICE_ANALYSIS_ROW:
          entityParams.id = 'investorId';
          entityParams.options = investors;
          break;

        default:
          break;
      }

      return (entityParams.options || []).reduce((acc, option) => {
        const { name, isAvailable } = option;
        const id = option[entityParams.id];

        if (isAvailable || id === entityId) {
          acc.push({ name, id });
        }

        return acc;
      }, []);
    },
  );
});
